export enum AntipatternType {
  AntipatternDetected = 'ANTIPATTERN_DETECTED',
  MotivationalFact = 'MOTIVATIONAL_FACT',
  FeelingStuck = 'FEELING_STUCK',
  SuggestedResources = 'SUGGESTED_RESOURCES',
}

export enum AntipatternTypeV2 {
  AntipatternHigh = 'Antipattern-High',
  AntipatternMedium = 'Antipattern-Medium',
  Informational = 'Informational',
  FeelingStuck = 'Feeling Stuck',
  Motivational = 'Motivational',
}

